export const datatable = [
    {
        name1:"Стоимость (₽)",
        name2:"Расчетное время обучения (мес.) *",
        block: 'Введение в программирование', 
        free: 'Бесплатно', 
        time: 0.5, 
        color: {
            "rgba": [255,255,255,1],
            "hex": "#000"
          }
    },
    { 
        name1:"Стоимость (₽)",
        name2:"Расчетное время обучения (мес.) *",
        block: 'Основы программирования на Python', 
        price: 9900, 
        time: 1
    },
    { 
        name1:"Стоимость (₽)",
        name2:"Расчетное время обучения (мес.) *",
        block: 'Python, продвинутый уровень', 
        price: 14900, 
        time: 2.5
    },
    { 
        name1:"Стоимость (₽)",
        name2:"Расчетное время обучения (мес.) *",
        block: 'Сети + фреймворк Flask', 
        price: 14900, 
        time: 2.5
    },
    {  
        name1:"Стоимость (₽)",
        name2:"Расчетное время обучения (мес.) *",
        block: 'Базы данных', 
        price: 14900, 
        time: 2
    },
    { 
        name1:"Стоимость (₽)",
        name2:"Расчетное время обучения (мес.) *",
        block: 'Фреймворк Django', 
        price: 14900, 
        time: 2
    },
    { 
        name1:"Стоимость (₽)",
        name2:"Расчетное время обучения (мес.) *",
        block: 'Разработка «боевого» проекта', 
        price: 9900, 
        time: 1.5
    }];